<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="aubio"><a class="page" id="piv"></a>Garrett Stewart is the James O. Freedman Professor of Letters in the Department of English at the University of Iowa and the author of numerous books on fiction and film.</p>
<p class="crtf">The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2015 by The University of Chicago</p>
<p class="crt">All rights reserved. Published 2015.</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">24 23 22 21 20 19 18 17 16 15  1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-20121-4 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-20149-8 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-20135-1 (e-book)</p>
<p class="crt">DOI: 10.7208/chicago/9780226201351.001.0001</p>
<p class="crtf">Library of Congress Cataloging-in-Publication Data</p>
<p class="crt">Stewart, Garrett, author.</p>
<p class="crt">Closed circuits : screening narrative surveillance / Garrett Stewart.</p>
<p class="crt">pages ; cm</p>
<p class="crt">Includes bibliographical references and index.</p>
<p class="crt"><span class="sm">ISBN</span> 978-0-226-20121-4 (cloth : alk. paper)— <span class="sm">ISBN</span> 978-0-226-20149-8 (pbk. : alk. paper)—</p>
<p class="crt"><span class="sm">ISBN</span> 978-0-226-20135-1 (ebook) 1. Electronic surveillance in motion pictures.</p>
<p class="crt">2. Motion pictures—United States—History and criticism. I. Title.</p>
<p class="crt">PN1995.9.E38S74 2015</p>
<p class="crt">791.430973—dc23</p>
<p class="crt">2014016861</p>
<p class="crtf">♾ This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48–1992 (Permanence of Paper).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-stewart-0004.vue?493e178b